/*
    class Auth: Auth0 class encapsulate authentication operations
 */
import {backendDomain, frontendDomain} from "./configs";
import axios from 'axios';

class Auth {
  constructor() {
    this.logout = this.logout.bind(this);
  }

  setSession(authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    console.log('session set.');

  }

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
  }

  isAuthenticated() {
    let accessToken = localStorage.getItem("access_token");
    let expiresAt = JSON.parse(localStorage.getItem('expires_at')); // parse time stamp from string to integer
    console.log(`checking authentication - expireAt: ${expiresAt} : ${new Date().getTime() < expiresAt}`);

    const doesAccessTokenExist = accessToken;
    const hasAccessTokenNotExpired = new Date().getTime() < expiresAt;
    return hasAccessTokenNotExpired && doesAccessTokenExist;
  }

  async login(username, password, reCaptchaCode) {
    const credentials = {
      username,
      password,
      reCaptchaCode
    }
    let authResult;
    try {
      const authResponse = await axios.post(`${backendDomain}/login`, credentials, { headers: {'Content-Type': 'application/json'} });
      authResult = authResponse.data;
    }
    catch (error) {
      this.logout();
      return error.response;
    }

    if (authResult && authResult.accessToken && authResult.idToken) {
      console.log("authenticated");
      this.setSession(authResult);
    } else {
      console.log('read stored authResult');
    }
    return 0;
  }

  getProfile(callback) {
    const idToken = this.getCachedToken('id_token');
    axios.post(`${backendDomain}/userinfo/profile`, { idToken: idToken }, { headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    } })
      .then(res => {
        console.log(res);
        callback(null, res.data);
      })
      .catch(err => {
        console.log("auth manager: getProfile error");
        callback(err, null);
      })
  }

  getCachedToken(tokenName) {
    const token = localStorage.getItem(tokenName);
    return token;
  }

  async signup(username, password, reCaptchaCode) {
    const credentials = {
      email: username,
      password,
      reCaptchaCode
    }
    let signupResult;
    try {
      const signupResponse = await axios.post(`${backendDomain}/signup`, credentials, {headers: {'Content-Type': 'application/json'}});
      signupResult = signupResponse.data;
    }
    catch (error) {
      const errObj = error.response;
      return errObj ? errObj.data.message : 'Unknown error happened while registering';
    }

    return 0;
  }

  async sendPasswordChangingEmail(username, reCaptchaCode) {
    let response;
    const params = {
      email: username,
      reCaptchaCode
    };
    const option = {headers: {'Content-Type': 'application/json'}};
    try {
      response = (await axios.post(`${backendDomain}/login/change_password`, params, option)).data;
    }
    catch (error) {
      if (error.message) {
        return error.message
      }
      return error.response && error.response.data ?
        error.response.data.message : 'Unknown error happened while sending password changing email';
    }
    return response;
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/modules/Auth0_setup.js